module.exports = __webpack_public_path__ + "static/step-3-2db68a3ee46fa484d943635d30b7c668.png";